module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-13.16f0c471.jpg";